import React from 'react';
import { Icon } from 'antd';
import styled from 'styled-components';
// @ts-ignore
import marked from 'marked';
import { Modal } from '../../components/Modal';
import { AISummaryData } from './aiSummaryApi';
import { FORUM_IAH_SALES_URL } from './constants';

interface IProps {
  visible: boolean;
  onClose: () => void;
  loading: boolean;
  notFound: boolean;
  error: string | null;
  data: AISummaryData | null;
}

const Body = styled.div`
  min-height: 180px;
  padding: 0.5rem 0.25rem;
  color: #1c1c1c;
`;

const SummaryContent = styled.div`
  white-space: pre-wrap;
  font-family: var(--title-font-family) !important;
  font-size: 16px;
  text-align: justify;
  line-height: 1.55;

  p {
    margin: 0 0 0.85rem 0;
  }

  h1, h2, h3, h4 {
    font-family: var(--title-font-family) !important;
    margin: 1rem 0 0.5rem 0;
  }

  ul, ol {
    padding-left: 1.25rem;
    margin: 0 0 0.85rem 0;
  }

  strong {
    font-weight: 600;
  }
`;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0;
  color: #595959;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 0.85rem;

  a {
    color: var(--primary-color, #d7282f);
    font-weight: 600;
  }
`;

const Title = (
  <span>
    <Icon type="thunderbolt" style={{ marginRight: 8 }} />
    Resumo com IA
  </span>
);

function extractSummaryText(data: AISummaryData | null): string | null {
  if (!data) return null;
  if (typeof data === 'string') return data;
  const text =
    (data as any).summary ||
    (data as any).markdown ||
    (data as any).content ||
    (data as any).text;
  return typeof text === 'string' && text.trim().length > 0 ? text : null;
}

function renderSummary(data: AISummaryData | null) {
  const summaryText = extractSummaryText(data);
  if (summaryText) {
    const html = marked(summaryText);
    return <SummaryContent dangerouslySetInnerHTML={{ __html: html }} />;
  }
  if (!data) return null;
  return <pre>{JSON.stringify(data, null, 2)}</pre>;
}

export const AISummaryModal = ({
  visible,
  onClose,
  loading,
  notFound,
  error,
  data
}: IProps) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      onOk={onClose}
      okText="Fechar"
      cancelButtonProps={{ style: { display: 'none' } }}
      title={Title}
      width={720}
      destroyOnClose
      footer={
        <Footer>
          <a href={FORUM_IAH_SALES_URL} target="_blank" rel="noopener noreferrer">
            Saiba mais sobre o Forum IAH
          </a>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'var(--primary-color, #d7282f)',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              padding: '0.4rem 1rem',
              cursor: 'pointer'
            }}>
            Fechar
          </button>
        </Footer>
      }>
      <Body>
        {loading && (
          <StatusRow>
            <Icon type="loading" /> Gerando resumo com IA...
          </StatusRow>
        )}

        {!loading && error && (
          <StatusRow>
            <Icon type="exclamation-circle" /> {error}
          </StatusRow>
        )}

        {!loading && !error && notFound && (
          <StatusRow>
            <Icon type="info-circle" /> Resumo ainda não disponível para este conteúdo.
          </StatusRow>
        )}

        {!loading && !error && !notFound && renderSummary(data)}
      </Body>
    </Modal>
  );
};
